import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine des classes Tailwind en résolvant les conflits.
 * Usage : cn('px-2 py-1', condition && 'bg-blue-500', 'px-4')
 * → 'py-1 bg-blue-500 px-4' (px-4 écrase px-2)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
